<script setup>
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import SelectCourse from "@/components/Dashboard/Utilities/Config/SelectCourse.vue";
import FileInput from "@/components/Dashboard/Utilities/MapFlags/FileInput.vue";
import useMapFlags from "@/scripts/Utilities/MapFlags";

const {
  map,
  drivingRangeMap,
  flag,
  logo,
  course,
  onUploadClicked,
  isFormValid,
  loading,
} = useMapFlags();
</script>

<template>
  <ContentHeader name="Map&Flags" :middleDots="true" />
  <section class="content">
    <div class="container-fluid">
      <div class="form-group">
        <div class="card">
          <div class="card-body">
            <div class="col-md-10"><SelectCourse v-model="course" /></div>
            <FileInput
              v-model="map"
              :maxSize="10485760"
              :label="'CHOOSE MAP FILE'"
            />
            <br />
            <FileInput
              v-model="flag"
              :maxSize="10485760"
              :label="'CHOOSE FLAG FILE'"
            />
            <br />
            <FileInput
              v-model="logo"
              :maxSize="10485760"
              :label="'CHOOSE LOGO FILE'"
            />
            <br />
            <FileInput
              v-model="drivingRangeMap"
              :maxSize="10485760"
              :label="'CHOOSE DRIVING RANGE MAP FILE'"
            />
            <br />
            <div class="input-group input-group-md col-md-4">
              <button
                @click="onUploadClicked"
                type="button"
                class="btn btn-info tm-btn-red fixed-width-button"
                :disabled="!isFormValid || loading"
              >
                <font-awesome-icon
                  v-show="loading"
                  :icon="['fas', 'spinner']"
                  spin
                />
                <span v-show="!loading">UPLOAD</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.fixed-width-button {
  width: 180px;
}
</style>
